import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';

export class SustainabilityFocusConfiguration extends ReportSectionConfigurationBase {
  typeName = 'SustainabilityFocusConfiguration';
  nodataLocalizationKeyName = 'sustainabilityFocus';
  readonly reportSection = ReportSection.SustainabilityFocus;
  readonly applicableReportTypes = [ReportType.Contact, ReportType.Institution];
  readonly reportViewModelSections = [ReportViewModelSection.InvestorProfile_SustainabilityFocus];
  minSize = 2;
  maxSize = 4;
  defaultSize = 4;
  readonly availableDataSections = [
    {
      name: 'sustainabilityFocusEnvironmental',
      displayName: 'Environmental',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'sustainabilityFocusSocial',
      displayName: 'Social',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'sustainabilityFocusGovernance',
      displayName: 'Governance',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'sustainabilityFocusOther',
      displayName: 'Other Approaches Considered',
      isSelected: true,
      canConfigure: true
    }
  ];

  get name(): string {
    if (this.appliedReportType === ReportType.Contact) {
      return 'contactSustainabilityFocus';
    } else if (this.appliedReportType === ReportType.Institution) {
      return 'institutionSustainabilityFocus';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.Contact || this.appliedReportType === ReportType.Institution) {
      return 'Sustainability Focus';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface ReportSustainabilityFocusData {
  [ReportViewModelSection.InvestorProfile_SustainabilityFocus]: {
    focuses: Focus[];
  };
}
export interface Focus {
  name: string;
  focusType: string;
  categories: Category[];
}

export interface Category {
  name: string;
}
